export const FormLabel = {
  baseStyle: {
    color: 'product.text.dark.header',
    _disabled: {
      color: 'blueGray.705',
    },
    fontSize: 'md',
    fontWeight: 'semibold',
  },
}
